import { Icon } from '@chakra-ui/react'
const CheckIcon = (props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M23 10.54V11.506C22.9987 13.7702 22.2656 15.9734 20.9098 17.787C19.554 19.6004 17.6485 20.9271 15.4771 21.5691C13.3058 22.2111 10.9851 22.134 8.86119 21.3493C6.73726 20.5646 4.92388 19.1145 3.69151 17.2149C2.45913 15.3154 1.87377 13.0684 2.02276 10.8092C2.17174 8.5498 3.04707 6.39915 4.51819 4.67793C5.98931 2.95672 7.97742 1.75717 10.186 1.25817C12.3946 0.759164 14.7053 0.987462 16.7735 1.90901" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.0001 3.10596L12.5001 13.6165L9.3501 10.4665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
  )
}

export default CheckIcon

